import {
  collection,
  doc,
  increment,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "../config/FirebaseConfig";

const SOCIAL_CLICKS_COLLECTION = "social_clicks";
const THROTTLE_STORAGE_PREFIX = "sette_social_click_throttle:";
const DEFAULT_THROTTLE_MS = 3000;

const PLATFORM_ALIASES = {
  tik_tok: "tiktok",
  linked_in: "linkedin",
  insta: "instagram",
};

const toDateId = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const normalizePlatform = (platform) => {
  const normalized = String(platform || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (!normalized) {
    return "";
  }
  return PLATFORM_ALIASES[normalized] || normalized;
};

const isThrottled = (key, ttlMs = DEFAULT_THROTTLE_MS) => {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    const storageKey = `${THROTTLE_STORAGE_PREFIX}${key}`;
    const now = Date.now();
    const lastTimestamp = Number(
      window.sessionStorage.getItem(storageKey) || 0,
    );
    if (lastTimestamp && now - lastTimestamp < ttlMs) {
      return true;
    }
    window.sessionStorage.setItem(storageKey, String(now));
  } catch (error) {
    return false;
  }
  return false;
};

const getSocialClickRefForToday = () =>
  doc(db, SOCIAL_CLICKS_COLLECTION, toDateId());

export const trackSocialClick = async (platform) => {
  const normalizedPlatform = normalizePlatform(platform);
  if (!normalizedPlatform || isThrottled(normalizedPlatform)) {
    return;
  }

  try {
    const dayRef = getSocialClickRefForToday();
    await setDoc(
      dayRef,
      {
        totalClicks: increment(1),
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );

    await setDoc(
      doc(collection(dayRef, "platforms"), normalizedPlatform),
      {
        platform: normalizedPlatform,
        clickCount: increment(1),
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );
  } catch (error) {
    console.error("Erro ao registrar clique em rede social:", error);
  }
};
